import React from 'react';
import { CheckIcon, ArrowSmRightIcon } from '@heroicons/react/outline';
import Link from 'next/link';
import { Button } from '@chakra-ui/react';

const features = [
  {
    name: 'Magic links',
    description: 'Make passwords obsolete by sending your users magic links'
  },
  {
    name: 'Session management',
    description: ' Revocable and stateless, the best of both worlds.'
  },
  {
    name: 'Multifactor authentication',
    description: 'Secure your users with multiple steps during sign in.'
  },
  {
    name: 'Social sign-in',
    description: 'Let your users sign in with Google, Facebook, and more'
  },
  {
    name: 'Multi-session management',
    description: 'Allow your users to sign in to multiple accounts at once.'
  },
  {
    name: 'New device notifications',
    description:
      "Proactively notify users when a new device signs in.  Let's your users protect themself."
  },
  {
    name: 'Password leak protection',
    description:
      'Proactively protects your users against passwords that appear in leaks.'
  },
  {
    name: 'Advanced security',
    description: 'Clerk detects and blocks phishy sign ins out of the box.'
  }
];

export function Powerful() {
  const featuresData = features;

  return (
    <>
      <div>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h3 className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
              Immensely powerful
            </h3>
            <p className="mx-auto mt-2 max-w-xl text-xl text-gray-500">
              The features your users <b>expect</b>.
            </p>
          </div>
        </div>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <dl className="mt-12 space-y-10 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-4 lg:gap-x-8">
            {featuresData.map(feature => (
              <div key={feature.name} className="relative">
                <dt>
                  <CheckIcon
                    className="absolute h-6 w-6 text-green-500"
                    aria-hidden="true"
                  />
                  <b className="ml-9 text-lg font-medium leading-6 text-gray-900">
                    {feature.name}
                  </b>
                </dt>
                <dd className="mt-2 ml-9 text-base text-gray-500">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
        <div className="mx-auto mt-16 max-w-md sm:flex sm:justify-center">
          <Link href={`${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-up`}>
            <Button
              rightIcon={<ArrowSmRightIcon className="inline h-6 w-6" />}
              minW="225px"
              fontSize={'md'}
            >
              Start Building Now
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
}
